// import emHome from "@/views/em/Home";

import sithMesIIRoutersPlan from "@/router/sithMesII/plan/moduleIndex-router-sithMesII-plan";
import sithMesIIRoutersPds from "@/router/sithMesII/pds/moduleIndex-router-sithMesII-pds";
import hazardRouters from "@/router/sithMesII/ehs/hazard-router";


export default [
    // {path: "/em", name: "emHome", component: emHome},
    ...sithMesIIRoutersPlan,
    ...sithMesIIRoutersPds,
    ...hazardRouters
]
